module.exports = __webpack_public_path__ + "img/company39.f81c6b07.png";